import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment, useContext, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../components/Button';
import GenericCard from '../../components/GenericCards/GenericCards';
import Pager from '../../components/Pager';
import Select from '../../components/Select';
import TextInput from '../../components/TextInput/TextInput';
import Chip from '../../components/TransactionStatus/Chip';
import {
  addOrRemoveDaysToGivenDate,
  DateFormats,
  formatDate,
} from '../../utils/utils';
import FilterPopover from '../widgets/filterPopover';
import {
  TransactionHistoryStore,
  TransactionHistoryProvider,
} from '../../providers/transactionHistory';

const transactionSelectOptions = [
  [
    { label: 'Health', value: '1' },
    { label: 'Pension', value: '2' },
    { label: 'Savings', value: '3' },
  ],
  [
    { label: 'Health and Welfare', value: '1' },
    { label: 'Retirement income Savings Plan', value: '2' },
  ],
  [
    { label: 'HSA One-Time Contribution', value: '1' },
    { label: 'Hardship Withdrawal', value: '2' },
    { label: 'HSA Per-Pay-Period Change', value: '3' },
    { label: 'Change Contributions', value: '4' },
    { label: 'Pension Election', value: '5' },
  ],
  [
    { label: 'Deleted', value: '1' },
    { label: 'Completed', value: '2' },
    { label: 'Pending', value: '3' },
  ],
];

const TransactionFilter = (
  <Fragment>
    <h6 className={'h6 mb-0 fw-normal'}>{'Filters'}</h6>
    <Select
      placeholder="Service"
      options={transactionSelectOptions[0]}
      className={'mt-7'}
    />
    <Select
      placeholder="Plan Name"
      options={transactionSelectOptions[1]}
      className={'mt-7'}
    />
    <Select
      placeholder="Transaction Type"
      options={transactionSelectOptions[2]}
      className={'mt-7'}
    />
    <Select
      placeholder="Status"
      options={transactionSelectOptions[3]}
      className={'mt-7'}
    />
  </Fragment>
);

function TableData() {
  const [currPage, setCurrPage] = useState(1);
  const { transactionHistory } = useContext(TransactionHistoryStore);

  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'money-check-dollar':
        return light('money-check-dollar');

      case 'hand-holding-dollar':
        return light('hand-holding-dollar');

      case 'heart-pulse':
        return light('heart-pulse');

      default:
        return light('alt');
    }
  };

  return (
    <Container className={'cnd-custom-container px-0 mt-11'}>
      <Container className={'px-7 px-lg-0 mb-11 mb-lg-12'}>
        <Row>
          <Col className={'col-8 col-lg-4'}>
            <h2 className={'text-sm-20-lg-24 mb-7 mb-lg-11'}>
              Transaction History
            </h2>

            <TextInput
              rightIcon={light('magnifying-glass')}
              placeholder={'Search'}
            />
          </Col>
          <Col
            className={
              'col-4 col-lg-8 d-flex justify-content-end align-items-end'
            }
          >
            <FilterPopover
              onFilter={() => console.log("I'm filtered")}
              popoverBody={TransactionFilter}
            >
              <Button leftIcon={light('filter')}>{'Filter'}</Button>
            </FilterPopover>
          </Col>
        </Row>
      </Container>
      <GenericCard variant={'white'}>
        <Row>
          <Col>
            <Row className={'d-none d-lg-flex border-bottom-dark-gray py-8'}>
              <Col className={'d-none d-lg-block col-lg-1 text-fs-6 m-0'}>
                Requested
              </Col>
              <Col className={'col-lg-2 ps-6 m-0'}>
                <span className={'text-fs-6 ms-11'}>Service</span>
              </Col>
              <Col className={'col-auto col-1 col-lg-3 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Plan Name</span>
              </Col>
              <Col className={'col-auto col-lg-2 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Transaction Type</span>
              </Col>
              <Col className={'col-lg-3 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Description</span>
              </Col>
              <Col className={'col-auto col-lg-1 text-fs-6 m-0'}>
                <span className={'text-fs-6'}>Status</span>
              </Col>
            </Row>
            {transactionHistory.map((transaction, index) => {
              return (
                <Row
                  className={
                    'striped-rows-fixed-children px-8 py-11 px-lg-0 py-lg-8 d-flex flex-lg-row flex-wrap align-items-center border-bottom border-info'
                  }
                  key={index}
                >
                  <Col className={'px-0 px-lg-5 col-3 col-lg-1 order-0'}>
                    <span className={'text-blue h3 text-fs-6 m-0'}>
                      {transaction['requestedDate']}
                    </span>
                  </Col>
                  <Col
                    className={
                      'col-3 col-lg-2 d-lg-flex align-items-start justify-content-lg-center order-1'
                    }
                  >
                    <span
                      className={'d-flex align-items-center h3 text-fs-6 m-0'}
                    >
                      <FontAwesomeIcon
                        className={'me-5'}
                        icon={getIcon(transaction['serviceIcon'])}
                      />
                      {transaction['serviceType']}
                    </span>
                  </Col>
                  <Col
                    className={
                      'ms-auto m-lg-0 col-auto col-lg-1 order-2 order-lg-5'
                    }
                  >
                    <div>
                      <Chip variant={transaction['status']} />
                    </div>
                  </Col>
                  <Col
                    className={
                      'd-flex d-lg-block align-items-center col-12 col-lg-3 order-3 py-6 px-5 mt-7 mt-lg-0 py-lg-0'
                    }
                  >
                    <h2
                      className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}
                    >
                      Plan Name
                    </h2>
                    <span
                      className={
                        'w-100 text-end text-lg-start h3 text-fs-6 m-0'
                      }
                    >
                      {transaction['planName']}
                    </span>
                  </Col>
                  <Col
                    className={
                      'd-flex d-lg-block align-items-center col-12 col-lg-2 order-4 order-lg-3 py-6 px-5 py-lg-0'
                    }
                  >
                    <h2
                      className={'d-lg-none col-auto h6 text-fs-6 m-0 pb-lg-8'}
                    >
                      Transaction Type
                    </h2>
                    <span
                      className={
                        'w-100 text-end text-lg-start h3 text-fs-6 m-0'
                      }
                    >
                      {transaction['transactionType']}
                    </span>
                  </Col>
                  <Col
                    className={
                      'd-flex d-lg-block align-items-center col-12 col-lg-3 order-5 order-lg-4 py-6 px-5 py-lg-0'
                    }
                  >
                    <h2 className={'d-lg-none h6 text-fs-6 m-0'}>
                      Description
                    </h2>
                    <span
                      className={
                        'w-100 text-end text-lg-start h3 text-fs-6 m-0'
                      }
                    >
                      {transaction['description']}
                    </span>
                  </Col>
                </Row>
              );
            })}
          </Col>
        </Row>
        <Container
          className={
            'px-0 mt-11 d-flex d-lg-block justify-content-center mt-11 mt-lg-10'
          }
        >
          <Pager
            pagesSize={3}
            currentPage={currPage}
            onPageChange={setCurrPage}
          />
        </Container>
      </GenericCard>
    </Container>
  );
}

const TransactionHistory = () => {
  return (
    <TransactionHistoryProvider>
      <TableData />
    </TransactionHistoryProvider>
  );
};

export default TransactionHistory;
